import { EventArg } from '@/types/metadata/metadata';

/**
 * The preset a stored event arg list corresponds to: the one declaring as many arguments as the list holds.
 * A label only picks between presets of that size, since it is free text and can be empty or renamed.
 */
export const findEventArgPreset = (presets: EventArg[] | undefined, labels: string[]): EventArg | undefined => {
  const sized = presets?.filter((preset) => preset.args.length === labels.length) ?? [];

  return sized.find((preset) => preset.args.every((arg, index) => arg.label === labels[index])) ?? sized[0];
};
